import cn from 'classnames'
import React from 'react'
import CollectionPreview from '../collectionpreview/CollectionPreview'

import { Skeleton } from '@nextui-org/react'

import { useTranslation } from 'react-i18next'

export const CollectionDisplayList = ({ category }) => {
    const { collections, isLoading } = category

    const { t } = useTranslation('common')

    return (
        <>
            <div
                className={cn(
                    'grid grid-cols-1 xs1:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 3xl:grid-cols-7 gap-4 sm:gap-8',
                    'justify-left text-left rounded-3xl',
                )}
            >
                {collections && !isLoading
                    ? collections.map((collection, index) => (
                          <CollectionPreview
                              key={collection.collection + '_' + index}
                              collection={collection}
                              category={category.key}
                          />
                      ))
                    : Array.from(new Array(24)).map(() => (
                          <Skeleton className="min-w-[240px] h-[320px] rounded-lg">
                              <div className="h-24 rounded-lg bg-default-300"></div>
                          </Skeleton>
                      ))}
            </div>

            {collections && collections.length === 0 && !isLoading && (
                <div className={'w-full flex items-center justify-center mt-4'}>
                    <p className={'text-base text-slate-400 font-medium'}>
                        {t('collection.no_items_found')}
                    </p>
                </div>
            )}
        </>
    )
}
